export default {
  middleware_url: "https://wip.tclm.fluid-it.fr",
  cake_url: "https://wip.cake.tclm.fluid-it.fr",
  isWavesoftEnabled: false,
  billingConforamaEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
};
